import React from 'react'

export default function PartnerSection() {
  return (
    <section id="partner" className="py-12 sm:py-16 bg-[#09130d] border-t border-[#183122]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-[#0e2116] to-[#0a170f] border border-[#1d3d28] rounded-3xl p-6 sm:p-10 lg:p-12 relative overflow-hidden shadow-2xl">
          {/* Subtle decoration */}
          <div
            className="pointer-events-none absolute -bottom-20 -right-20 w-80 h-80 rounded-full bg-emerald-600/10 blur-3xl"
            aria-hidden="true"
          />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative z-10">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-[#132c1e] border border-[#1f4b30] text-xs font-semibold uppercase tracking-wider text-emerald-300 mb-4">
                <i className="fa-solid fa-handshake-angle text-xs" aria-hidden="true" />
                <span>Partner Company</span>
              </div>
              
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight">
                Kinetic Biofuel
              </h2>

              <p className="mt-4 text-base sm:text-lg text-neutral-300 leading-relaxed max-w-2xl">
                You are also welcome to consult the homepage of our partner company Kinetic Biofuel –{' '}
                <a
                  href="https://www.kineticbiofuel.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-emerald-400 font-semibold hover:text-emerald-300 underline underline-offset-4 decoration-emerald-500/60 hover:decoration-emerald-300 transition-colors whitespace-nowrap"
                >
                  www.kineticbiofuel.com
                </a>{' '}
                – where Mr. Torben A. Bonde and co-workers may also be contacted at{' '}
                <a
                  href="mailto:tab@kineticbiofuel.com"
                  className="text-emerald-400 font-semibold hover:text-emerald-300 underline underline-offset-4 decoration-emerald-500/60 hover:decoration-emerald-300 transition-colors whitespace-nowrap"
                >
                  tab@kineticbiofuel.com
                </a>
              </p>

              <div className="mt-8 flex flex-wrap items-center gap-4">
                <a
                  href="https://www.kineticbiofuel.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2.5 px-5 py-3 rounded-xl font-semibold text-xs sm:text-sm text-neutral-950 bg-emerald-400 hover:bg-emerald-300 transition-colors shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400"
                >
                  <span>Visit Kinetic Biofuel</span>
                  <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
                </a>

                <a
                  href="mailto:tab@kineticbiofuel.com"
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl font-semibold text-xs sm:text-sm text-white bg-[#142d1f] hover:bg-[#1a3a28] border border-[#235035] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 whitespace-nowrap"
                >
                  <i className="fa-solid fa-envelope text-emerald-400 text-xs" aria-hidden="true" />
                  <span>tab@kineticbiofuel.com</span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-4 flex justify-center lg:justify-end">
              <div className="bg-[#12281a] border border-[#20442c] rounded-2xl p-6 sm:p-7 max-w-sm w-full text-center">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#193c26] to-[#0f2417] border border-emerald-500/30 text-emerald-400 flex items-center justify-center text-2xl mx-auto mb-4 shadow-inner">
                  <i className="fa-solid fa-globe" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-bold text-white tracking-tight">
                  Kinetic Biofuel
                </h3>
                <p className="mt-1 text-xs text-neutral-400">
                  Partner in Bioenergy & Biomass Innovation
                </p>
                <div className="mt-5 pt-4 border-t border-[#1a3824]">
                  <a
                    href="https://www.kineticbiofuel.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs font-semibold text-emerald-400 hover:text-emerald-300 transition-colors inline-flex items-center gap-1.5"
                  >
                    <span>www.kineticbiofuel.com</span>
                    <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
